module.exports = __webpack_public_path__ + "static/img/323_TO8_2501_og.bee8daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/323_TO8_2501_og.jpg
// module id = /KrA
// module chunks = 0